export const ExpandScreenIcon = (
  <svg className="size-4" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.3335 10.5V7.58331C2.3335 4.67831 4.6785 2.33331 7.5835 2.33331H10.5002"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.501 2.33331H20.4176C23.3226 2.33331 25.6676 4.67831 25.6676 7.58331V10.5"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.667 18.6667V20.4167C25.667 23.3217 23.322 25.6667 20.417 25.6667H18.667"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5002 25.6667H7.5835C4.6785 25.6667 2.3335 23.3217 2.3335 20.4167V17.5"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
